'use client';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';

export default function ConnectionBanner() {
  const { isOnline } = useNetworkStatus();
  if (isOnline) return null;

  return (
    <div role="alert" className="fixed top-0 left-0 right-0 z-[200] bg-amber-500 text-white text-center py-2 text-sm font-bold shadow-lg">
      <span>⚠️ 오프라인 상태입니다. 변경사항이 저장되지 않을 수 있습니다.</span>
    </div>
  );
}
